export default __webpack_public_path__ + "locales/sk/Translations.json?hash=da2270ac0df641ca5bfd5113b24f0773";